const fragmentCategory = `
  fragment CategoryFields on CategoryTree {
    id  
    is_anchor
    name
    position
    product_count
    uid
    url_path
    url_suffix
    image
    include_in_menu
    anchor_to_menu
    description
    editorial_box_1
    editorial_box_2
    related_filter_code
    editorial_box_1_position
    editorial_box_2_position
    description_footer
    related_filter_value
  }
`;

export default `
  query categoryList {
    categories {
      items {
        ...CategoryFields
        children {
          ...CategoryFields
          children {
            ...CategoryFields
            children {
              ...CategoryFields
            }
          }
        }
      }
    }
  }
  ${fragmentCategory}
`;
